import { makeDataState, STATUSES } from 'app/utils/redux';

import * as t from './types';

const initialState = {
  communityPost: makeDataState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    // fetch communityPost
    case `${t.FETCH_COMMUNITY_POST}_PENDING`:
      return {
        ...state,
        communityPost: {
          ...state.communityPost,
          status: STATUSES.PENDING,
        },
      };

    case `${t.FETCH_COMMUNITY_POST}_SUCCESS`:
      return {
        ...state,
        communityPost: {
          ...state.communityPost,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          data: action.payload.result,
        },
      };

    case `${t.FETCH_COMMUNITY_POST}_ERROR`:
      return {
        ...state,
        communityPost: {
          ...state.communityPost,
          status: STATUSES.ERROR,
        },
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/communityPostCreateEdit/reducer.js